<template>
    <div class="knd-logboek">
        
        <div class="knd-chat-operator">
	<div class="chat knd-pb-5 knd-bg-red-dark">
		<div class="chat-header knd-bg-red-light knd-pt-5 knd-border-b-2 knd-border-green-light">
			<div class="knd-flex knd-wrapper__xl knd-m-auto">
				<div class="chat-header__tab knd-border-2 knd-border-green-light knd-px-2 knd-py-2 knd-mr-1">Mark55</div>
				<div class="chat-header__tab knd-border-2 knd-border-green-light knd-px-2 knd-py-2 knd-mr-1">Dick</div>
				<div class="chat-header__tabknd-wrapper__xl knd-border-2 knd-border-green-light knd-px-2 knd-py-2 knd-mr-1">Marcel</div>
				<div class="chat-header__tab knd-border-2 knd-border-green-light active knd-bg-green-light knd-px-2 knd-py-2 knd-mr-1">{{$store.state.user.name}}</div>
				<div class="chat-header__tab knd-border-2 knd-border-green-light knd-px-2 knd-py-2 knd-mr-1">Johny</div>
			</div>
		</div>
        <ChatContainer :content="content" />

	</div>
    <div class="knd-logboek__content knd-bg-red knd-text-white">
        <div class="knd-wrapper__xl">
            <div class="knd-mb-5 knd-py-2 knd-logboek__header knd-flex knd-items-center">
                <svg width="20" height="9" viewBox="0 0 20 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="1.5" y1="1.5" x2="18.5" y2="1.5" stroke="#FFF" stroke-width="3" stroke-linecap="round"/>
                    <line x1="1.5" y1="7.5" x2="18.5" y2="7.5" stroke="#FFF" stroke-width="3" stroke-linecap="round"/>
                </svg>
                <span class="knd-pl-2">Logboek</span>
            </div>
            <div class="knd-flex knd-logboek__meta justify-start">
                <div class="knd-mr-5 knd-pr-5">{{$store.state.user.name}}</div>
                <div class="knd-mr-5 knd-pr-5">{{$store.state.user.work}}</div>
                <div class="knd-mr-5 knd-pr-5">leeftijd onbekend</div>
            </div>
            <div class="knd-my-5">
                <div class="knd-logboek__comment">
                    Getrouwd geweest, partner 3 jaar geleden overleden
                </div>
                <div class="knd-logboek__comment">
                    Heeft een zoon, houdt ook van {{$store.state.user.hobby}}
                </div>
                <div class="knd-logboek__comment">
                    Is op vakantie voor een week
                </div>   
            </div>         

        </div>
    </div>

    </div>    
    </div>
</template>

<script>
    import ChatContainer from './chat/chat-container.vue';

    export default {
        props: {
            content: {
                type: Object
            }
        },
        components: {ChatContainer},

        mounted () {},
    }
</script>

<style lang="scss" scoped>

    .knd-logboek__header {
        border-bottom: 1px solid #FFF;
    }
    .knd-logboek__meta {
        div {
            border-right: 1px solid #FFF;
        }
    }

    .knd-logboek__comment {
        border-bottom: 1px dashed #FFF;
        padding-bottom: 0.5rem;
        padding-top: 0.5rem; 

        &:first-of-type {
            border-top: 1px dashed #FFF;
        }
    }
</style>